/* Chess4pro · tanda 32 (aprobada 02/11): sobre-nosotros-v2 (la línea del tiempo se dibuja al entrar en pantalla) y video-taza B
   (cabecera de la colección de tazas: vídeo de Veo en bucle y sin sonido; con "reducir movimiento" solo se ve el póster;
   se para fuera de la vista, con la pestaña oculta y con el botón de pausa). */
(() => {
  if (window.__c4pT20) return; window.__c4pT20 = true;
  const mq = matchMedia('(prefers-reduced-motion: reduce)');
  const hasIO = 'IntersectionObserver' in window;

  const timeline = () => document.querySelectorAll('.c4p-ab13__tl:not([data-tl])').forEach((s) => {
    s.dataset.tl = '1';
    if (mq.matches || !hasIO || s.getBoundingClientRect().top < innerHeight * 0.85) return;
    s.classList.add('is-pre');
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { s.classList.remove('is-pre'); io.disconnect(); } }, { rootMargin: '0px 0px -15% 0px' });
    io.observe(s);
  });

  const video = () => document.querySelectorAll('.c4p-wall--video:not([data-vd])').forEach((w) => {
    w.dataset.vd = '1'; /* data-on ya lo pone el muro (c4p-t7.js) */
    const v = w.querySelector('video'), b = w.querySelector('.c4p-wall__pp'); if (!v || !b) return;
    let L = {}; try { L = JSON.parse(b.dataset.l || '{}'); } catch (e) {}
    let paused = false, vis = !hasIO, played = false;
    const label = () => { b.dataset.paused = paused ? '1' : '0'; b.setAttribute('aria-label', paused ? (L.play || 'Play') : (L.pause || 'Pause')); };
    const sync = () => {
      const still = mq.matches;
      w.classList.toggle('c4p-wall--still', still);
      if (still) { if (played) { v.pause(); v.load(); played = false; } return; }
      if (paused || !vis || document.hidden) { v.pause(); return; }
      v.preload = 'auto'; v.muted = true;
      const p = v.play(); played = true; if (p && p.catch) p.catch(() => {});
    };
    b.addEventListener('click', () => { paused = !paused; label(); sync(); });
    if (hasIO) new IntersectionObserver((es) => { vis = es[es.length - 1].isIntersecting; sync(); }, { threshold: 0.15 }).observe(w);
    document.addEventListener('visibilitychange', sync);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    label(); sync();
  });

  const init = () => { timeline(); video(); };
  init();
  document.addEventListener('shopify:section:load', init);
})();
